import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import "./PaymentModal.css"
import { useDispatch } from 'react-redux';
import { updateFoodQuantityCart } from '../../redux/actions/cartActions';

function PaymentModal({ show, handleClose, amount }) {

  const dispatch = useDispatch();

  const onPay = () => {
    dispatch(updateFoodQuantityCart([])) 
    handleClose()
   }

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='payment-container'>
            <p>Total Payment: <span className='cart-price'>₹ {amount}</span></p>
            <p className='payment-method-title'>Select Payment Method</p>
            <Form.Select>
              <option>PhonePe</option>
              <option>GPay</option>
              <option>Paytm</option>
            </Form.Select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

          <Link to="/paymentSuccess">
            <Button variant="primary" onClick={onPay}>
              Pay
            </Button>
          </Link>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PaymentModal;